import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { ModalDialogComponent } from '@vg-constellation/angular-19/modal-dialog';
import { ModalDialogVariant } from '@vg-constellation/angular-19/modal-dialog/modal-dialog.component';

@Component({
  selector: 'app-confirm-submit',
  standalone: false,
  templateUrl: './confirm-submit.component.html',
  styleUrl: './confirm-submit.component.scss',
})
export class ConfirmSubmitComponent {
  @ViewChild('confirmationModal', { static: true }) confirmationModal!: ModalDialogComponent;

  @Input() headingText = 'Are you sure?';
  @Input() bodyText?: string;
  @Input() confirmButtonText = 'Confirm';
  @Input() cancelButtonText = 'Cancel';
  @Input() confirmButtonVariant: 'primary' | 'secondary' = 'primary';
  @Input() variant: ModalDialogVariant;

  @Output() confirmEvent = new EventEmitter<void>();
  @Output() cancelEvent = new EventEmitter<void>();
  @Output() closeEvent = new EventEmitter<void>();

  openModalDialog(): void {
    this.confirmationModal?.openModalDialog();
  }

  closeDialogModal(): void {
    this.confirmationModal?.closeDialogModal();
  }

  onConfirm(): void {
    this.confirmEvent.emit();
  }

  onCancel(): void {
    this.cancelEvent.emit();
  }

  onClose(): void {
    this.closeEvent.emit();
  }
}
